/**
 * Coach–client relationship (client view) – check if current user has an assigned coach.
 */
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  limit,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'coachClients';

export async function getMyCoachId(clientId) {
  const q = query(
    collection(db, COLLECTION),
    where('clientId', '==', clientId),
    limit(1)
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;
  return snap.docs[0].data().coachId;
}

async function getActiveByClient(clientId) {
  const snap = await getDocs(
    query(
      collection(db, COLLECTION),
      where('clientId', '==', clientId),
      where('relationshipStatus', '==', 'active'),
      limit(1)
    )
  );
  if (snap.empty) return null;
  const d = snap.docs[0];
  const data = d.data();
  return {
    id: d.id,
    coachId: data.coachId || '',
    clientId: data.clientId || '',
    relationshipStatus: data.relationshipStatus || 'active',
    startDate: data.startDate?.toDate?.() ?? data.startDate ?? null,
    createdAt: data.createdAt?.toDate?.() ?? data.createdAt ?? null,
  };
}

async function end(relId) {
  await updateDoc(doc(db, COLLECTION, relId), {
    relationshipStatus: 'ended',
    endedAt: serverTimestamp(),
  });
}

export const coachClientRepo = { getMyCoachId, getActiveByClient, end };
